import React, {useEffect, useMemo, useState} from 'react';
import {HStack, Stack, VStack, Text as NBText} from "native-base";
import SharedTimepicker from "../../../../../common/SharedTimepicker";
import moment from "moment";
import {
    dbDateFormat,
    dbTimeFormat,
    getHourAndMinuteDiff,
    isBoxIL,
    isMobile, sendDataEvent,
    sortDays, resolveEventCategoryType
} from "../../../../../../services/Helpers";
import {GlobalStyleAttributes, WebGlobalStyles} from "../../../../../../styles/GlobalStyles";
import AppText from "../../../../../common/AppText";
import {t} from "../../../../../../services/i18n";
import {Colors} from "../../../../../../styles/Colors";
import {useDispatch, useSelector} from "react-redux";
import {fetchApi} from "../../../../../../services/HTTP";
import {getCategoriesByTypes} from "../../../../../../redux/ScheduleSlice";
import {ActivityIndicator} from "react-native";
import {optionalSteps} from "../StepOptions";
import {updateSummary, updateTempSelection} from "../../../../../../redux/stepperSlice";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import {COACH_SELECT, SINGLE_SESSION_EDIT_TYPE, SPACE_SELECT} from "../../../../../../services/ConstHelper";
import {generateSeriesName} from "../../../../../../services/ScheduleService";
import SimpleInput from "../../../../../common/SimpleInput";
import {isString} from "formik";
import {flowOptions} from "../FlowOptions";
import CustomCheckbox from "../../../../../common/CustomCheckbox";
import {Radio} from "antd";
import InfoTooltip from "../../../../../common/InfoTooltip";
import MultiSingleMenuWithSearch from "../../../../../common/MultiSingleMenuWithSearch";
import CustomButtonV2 from "../../../../../common/CustomButtonV2";
import useCheckPermissions from '../../../../../../Hooks/useCheckPermission';
import {checkRequired} from "../../../../../../services/stepperService";
import { openModal, SETTINGS_VALUE_MODAL } from '../../../../../../redux/modalManagerSlice';
import { HUG_DESCRIPTION } from '../../../../../../Configs/SettingsValueModalOptions';

const MultiDayConfiguration = (props) => {
    const { values, errors, setFieldValue, touched, showLocationSelect, showCoachSelect, showSpacesSelect, spaceName, servicesTypeOverride, showUnlimitedOption, showShortenName, validationObject, updateDatesBySeason, showDayDescription } = props;
    const box = useSelector((state) => state.box.box);
    const flowName = useSelector((state) => state.stepper.name);
    const selectedLocation = useSelector((state) => state.userSettings.scheduleLocation);
    const services = useSelector(state => state.schedule.eventTypes.data)
    const selectionsTree = useSelector((state) => state.stepper.selectionsTree);
    const eventTypeKey = useMemo(() => {
        const selected = selectionsTree?.[optionalSteps.EVENT_TYPE];
        return resolveEventCategoryType(selected) ?? selected;
    }, [selectionsTree]);
    const lang = useSelector((state) => state.userSettings.lang);
    const [coaches, setCoaches] = useState(null);
    const [selectedCoachName, setSelectedCoachName] = useState(null);
    const [selectedSpaceName, setSelectedSpaceName] = useState(spaceName ?? null);
    const [boxLocale] = useState(lang?.language === 'Hebrew' ? 'he' : 'en');
    const { hasLimitedCoachViewSchedule } = useCheckPermissions();
    const mobile = isMobile
    const days = useMemo(() => ({
        0: {name: t(mobile ? 'sundayShortened' : 'sunday'), id: 0},
        1: {name: t(mobile ? 'mondayShortened' : 'monday'), id: 1},
        2: {name: t(mobile ? 'tuesdayShortened' : 'tuesday'), id: 2},
        3: {name: t(mobile ? 'wednesdayShortened' : 'wednesday'), id: 3},
        4: {name: t(mobile ? 'thursdayShortened' : 'thursday'), id: 4},
        5: {name: t(mobile ? 'fridayShortened' : 'friday'), id: 5},
        6: {name: t(mobile ? 'saturdayShortened' : 'saturday'), id: 6}
    }), [])
    const daysWithOrder = useMemo(() => {
        if(days) {
            if (isBoxIL()) return Object.values(days);
            else return [days['1'], days['2'], days['3'], days['4'], days['5'], days['6'], days['0']]
        }
    }, [days]);
    const defaultEndTime = useMemo(() => (values.multiDayConfig && 'days' in values.multiDayConfig && values.multiDayConfig?.days.length > 0) ? values.multiDayConfig?.days[0].end_time : null,[values.multiDayConfig])
    const timeFormat = useMemo(() => box ? box.locations_box[0].time_format : null,[box])
    const dateFormat = useMemo(() => box ? box.locations_box[0].date_format : null,[box])
    const locations = useMemo(() => box ? box.locations_box.reduce((acc, location) => [...acc, {...location, label: location.location, value: location.id}],[]) : null, [box])
    const spaces = useMemo(() => (selectedLocation?.spaces || []).reduce((acc, space) => [...acc, {...space, label: space.name, value: space.id}], []),[selectedLocation])
    const sessionTypes = useMemo(() => {
        if(services) {
            if(eventTypeKey) return services[eventTypeKey].filter(service => !!service.active)
            else if(servicesTypeOverride) return services[servicesTypeOverride].filter(service => !!service.active)
        }
        return null
    },[services, eventTypeKey, servicesTypeOverride])
    const dispatch = useDispatch()

    useEffect(() => {
        sendDataEvent('workshop or availability step');
    }, []);

    useEffect(() => {
        if('coach_ub_id' in values && !coaches) fetchCoaches()
        if(!services) dispatch(getCategoriesByTypes(true))
    }, [values]);

    useEffect(() => {
        if(values?.multiDayConfig?.days && 'seriesName' in values?.multiDayConfig) {
            callGenerateSeriesName()
        }
    }, [values?.multiDayConfig?.days, values?.end_date, values?.start_date]);

    useEffect(() => {
        if(box) {
            if(box.locations_box.length === 1 && 'location_fk' in values) {
                setFieldValue('location_fk', box.locations_box[0].id)
            }
        }
    }, [box]);

    useEffect(() => {
        if(coaches && values.coach_ub_id) {
            const coach = coaches.find(coach => coach.id === values.coach_ub_id)
            setSelectedCoachName(coach.name)
        }
    }, [values.coach_ub_id, coaches]);

    useEffect(() => {
        if(spaces && values.spaces_id) {
            const space = spaces.find(space => space.id === values.spaces_id)
            setSelectedSpaceName(space?.name)
        }
    }, [values.spaces_id, spaces]);

    useEffect(() => {
        if(selectedLocation && Object.keys(values).length && !values.location_fk) {
            setValue('location_fk', selectedLocation.id)
        }
    }, [selectedLocation, values.location_fk]);

    useEffect(() => {
        if('spaces_id' in values && spaces && spaces.length === 1) {
            setFieldValue('spaces_id', spaces[0].id)
        }
    }, [spaces]);

    useEffect(() => {
        if(values.start_date && values.isOneDay && values.start_date !== values.end_date) {
            setFieldValue('end_date', values.start_date)
        }
    }, [values.start_date]);

    useEffect(() => {
        if(updateDatesBySeason && values.season_id && !values.seasonInitDate) {
            const season = box.seasons.find(s => s.id === values.season_id)
            if(season && season.start_date && season.end_date) {
                setFieldValue('start_date', season.start_date)
                setFieldValue('end_date', season.end_date)
                setFieldValue('seasonInitDate', true)
            }
        }
    }, [updateDatesBySeason, values.season_id]);

    useEffect(() => {
        if((values.spaces_id || values.coach_fk || values.second_coach_fk) && values.isOneDay) {
            const dayObj = values.multiDayConfig.days[0]
            let spaces = values.spaces_id ? [values.spaces_id] : []
            if(values.spaces_relation?.length) {
                const spaceRelation = values.spaces_relation?.reduce((acc, sr) => sr.id ? [...acc, sr.id] : acc, [])
                spaces = [...spaces, ...spaceRelation]
            }
            dispatch(updateTempSelection({
                spaces_id: spaces,
                date: values.start_date,
                start_time: dayObj.start_time,
                end_time: dayObj.end_time,
                coach_id: values.coach_fk,
                second_coach_id: values.second_coach_fk,
            }))
        } else {
            dispatch(updateTempSelection(null))
        }
    }, [values.spaces_id, values.isOneDay, values.multiDayConfig, values.start_date, values.spaces_relation, values.coach_fk, values.second_coach_fk]);

    const onDateChange = (name, value) => {
        const date = moment(value).format(dbDateFormat)
        setFieldValue(name, date)
    }

    const toggleDay = (isOpen, dayId) => {
        //the checkbox wrapper with pressable is a workaround because checkbox onchange is buggy without checkbox-group
        let newDays = [...values.multiDayConfig.days.filter(d => d.day !== dayId)]
        if(isOpen) {
            newDays = [...newDays, {day: dayId, start_time: props?.eventDateTime?.start ?? values.multiDayConfig?.days[0]?.start_time ?? '07:00:00', end_time: defaultEndTime ?? '17:00:00'}]
        }
        setFieldValue('multiDayConfig.days', newDays)
    }

    const toggleDayFromArray = (isOpen, dayId) => {
        let newDays = [...values.multiDayConfig.filter(d => d.day !== dayId)]
        if(isOpen) {
            newDays = [...newDays, {day: dayId, setting: [{start_time: '07:00:00', end_time: '17:00:00', limitations: []}]}]
        }
        setFieldValue('multiDayConfig', newDays)
    }

    const onTimeChange = (name, value) => {
        const time = value.format(dbTimeFormat)
        setFieldValue(name, time)
        if(name?.includes('start_time')) {
            if(services && eventTypeKey && services[eventTypeKey]) {
                const event = services[eventTypeKey].find(t => t.id === values.box_category_fk)
                // only set end_time if event is found
                if (event) {
                    setFieldValue(name.replace('start_time', 'end_time'), moment(value, dbTimeFormat).add(event.length, 'minutes').format(dbTimeFormat))
                }
            }
        }
    }

    const openAddDescription = (selectedDayIndex) => {
        const val = values.multiDayConfig.days[selectedDayIndex]?.description
        const onChange = (value) => setFieldValue(`multiDayConfig.days[${selectedDayIndex}].description`, value)
        dispatch(openModal({ modalName: SETTINGS_VALUE_MODAL, props: {type: HUG_DESCRIPTION, onChange, initialValue: val}}))
    }

    const callGenerateSeriesName = () => {
        const boxCategoryName = sessionTypes.find(type => type.id === values.box_category_fk).name
        const seriesName = generateSeriesName(values.multiDayConfig.days, values.start_date, values.end_date, dateFormat, timeFormat, showShortenName, t, boxCategoryName)
        setFieldValue('multiDayConfig.seriesName', seriesName)
    }

    const generateSummary = () => {
        const date = moment(values.start_date ,dbDateFormat).format(lang?.language == 'Hebrew' ? 'DD MMM, YYYY' : 'MMM DD, YYYY');
        let timeDict = {}
        const sortedDays = values.multiDayConfig?.days.sort((a, b) => sortDays(a.day, b.day))

        sortedDays.map(day => {
            const startTime = moment(day.start_time, dbTimeFormat).format(timeFormat)
            const endTime = moment(day.end_time, dbTimeFormat).format(timeFormat)
            const hourRangeText = `${t('fromTime')} ${startTime} ${t('toTime')} ${endTime}`
            timeDict[hourRangeText] = timeDict[hourRangeText] ? [...timeDict[hourRangeText], day.day] : [day.day]
        })
        return getSummaryFromHourDictionary(timeDict, date)
    }

    const generateSummaryFromArray = () => {
        const date = moment(values.date,dbDateFormat).format(lang?.language == 'Hebrew' ? 'DD MMM, YYYY' : 'MMM DD, YYYY');
        let timeDict = {}
        const sortedDays = values.multiDayConfig.sort((a, b) => sortDays(a.day, b.day))

        sortedDays.map(day => {
            day.setting.map(setting => {
                const startTime = moment(setting.start_time, dbTimeFormat).format(timeFormat)
                const endTime = moment(setting.end_time, dbTimeFormat).format(timeFormat)
                const hourRangeText = `${t('fromTime')} ${startTime} ${t('toTime')} ${endTime}`
                timeDict[hourRangeText] = timeDict[hourRangeText] ? [...timeDict[hourRangeText], day.day] : [day.day]
            })
        })

        return getSummaryFromHourDictionary(timeDict, date)
    }

    const getSummaryFromHourDictionary = (timeDict, date) => {
        let daysAndTimes = ''
        daysAndTimes = Object.keys(timeDict).reduce((acc, hours, i) => {
            const days = timeDict[hours].reduce((acc, day) => [...acc, t(`day-${day+1}`)],[])
            return `${acc} ${days.join(` ${t('and')} `)} ${hours}${i !== Object.keys(timeDict).length -1 ? ', ' : ''}`
        }, '');
        const startDate = values.start_date ? moment(values.start_date, dbDateFormat).locale(boxLocale).format(lang?.language == 'Hebrew' ? 'DD MMM, YYYY':'MMM DD, YYYY') : null;
        const endDate = values.end_date ? moment(values.end_date, dbDateFormat).locale(boxLocale).format(lang?.language == 'Hebrew' ? 'DD MMM, YYYY':'MMM DD, YYYY') : null;
        const summary = t(`${flowName}-summary${values.isOneDay ? '-oneDay' : values.isUnlimited ? '-unlimited' : ''}`, {date: date, daysAndTimes: daysAndTimes, coach: selectedSpaceName ?? selectedCoachName ?? '', startDate, endDate})
        dispatch(updateSummary(summary))
        return `${t('summary-label')} ${summary}`
    }

    const fetchCoaches = async () => {
        let coachesRes = await fetchApi('getCoachesOfBox', 'get', null, false, true);
        coachesRes.forEach(coach => {
            coach.label = `${coach.first_name} ${coach.last_name}`
            coach.value = coach.id
            return coach
        })
        setCoaches(coachesRes);
        if(coachesRes.length === 1) {
            setFieldValue('coach_ub_id', coachesRes[0].id)
        }
    }

    const setValue = (name, value, shouldParseInt = false) => {
        console.log('setValue', name, value, typeof value)
        setFieldValue(name, shouldParseInt ? (isNaN(parseInt(value)) ? '' : parseInt(value)) : value)
    }

    const addSettingToDay = (index) => {
        let newSetting = [...values.multiDayConfig[index].setting]
        newSetting = [...newSetting, {start_time: '18:00:00', end_time: '20:00:00', limitations: []}]
        setFieldValue(`multiDayConfig[${index}].setting`, newSetting)
    }

    const removeSettingFromDay = (indexInArray, indexInSetting) => {
        let newSetting = [...values.multiDayConfig[indexInArray].setting]
        newSetting.splice(indexInSetting, 1)
        setFieldValue(`multiDayConfig[${indexInArray}].setting`, newSetting)
    }

    const handleLimitationChange = (limitations, indexInArray, indexInSetting) => {
        setFieldValue(`multiDayConfig[${indexInArray}].setting[${indexInSetting}].limitations`, limitations)
    }

    const onUnlimitedSelectChange = (selected) => {
        if(selected === 'oneDay') {
            setFieldValue('isOneDay', true)
            setFieldValue('isUnlimited', false)
            setFieldValue('end_date', values.start_date)
            const date = moment(values.start_date, dbDateFormat)
            let newDays = values.multiDayConfig.days.filter(day => day.day === date.day())
            if(newDays.length === 0) {
                if(values.multiDayConfig.days.length === 1) {
                    newDays = [{...values.multiDayConfig.days[0], day: date.day()}]
                } else {
                    newDays = [{start_time: '09:00:00', end_time: '17:00:00', day: date.day()}]
                }
            }
            setFieldValue('multiDayConfig.days', newDays)
        } else {
            setFieldValue('isOneDay', false)
            setFieldValue('isUnlimited', selected === 'unlimited')
            const end_date = values.start_date ? moment(values.start_date, dbDateFormat).add(1, 'month').format(dbDateFormat) : moment().add(1, 'month').format(dbDateFormat)
            setFieldValue('end_date', selected === 'unlimited' ? null : end_date)
        }
    }

    return (
        <>
            {
                !('coach_ub_id' in values) || ('coach_ub_id' in values && coaches)
                ?
                <VStack space={'1.2rem'}>
                    { showCoachSelect && coaches &&
                        <VStack space={'0.2rem'}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('coach')}{checkRequired('coach_ub_id', validationObject)}</AppText>
                            <AdvanceSelect options={coaches} initValue={values.coach_ub_id} type={COACH_SELECT} target={{name: 'coach_ub_id', value: 'id'}} onChange={(val) => setValue('coach_ub_id', val?.id)} isClearable={true} isError={errors.coach_ub_id && touched.coach_ub_id} isDisabled={hasLimitedCoachViewSchedule}/>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.coach_ub_id && touched.coach_ub_id ? errors.coach_ub_id : ''}</AppText>
                        </VStack>
                    }
                    { showLocationSelect && locations.length > 1 && 'location_fk' in values &&
                        <VStack space={'0.2rem'}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('location')}{checkRequired('location_fk', validationObject)}</AppText>
                            <AdvanceSelect options={locations} initValue={values.location_fk} onChange={(val) => setValue('location_fk', val?.id)} isError={!!errors.location_fk}/>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.location_fk}</AppText>
                        </VStack>
                    }
                    { showSpacesSelect && spaces &&
                        <VStack space={'0.2rem'}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('space')}{checkRequired('spaces_id', validationObject)}</AppText>
                            <AdvanceSelect type={SPACE_SELECT} options={spaces} initValue={values.spaces_id} onChange={(val) => setValue('spaces_id', val?.id)} isClearable={true} isError={errors.spaces_id && touched.spaces_id}/>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.spaces_id && touched.spaces_id ? errors.spaces_id : ''}</AppText>
                        </VStack>
                    }
                    <VStack space={'0.2rem'}>
                        <HStack space={'0.5rem'} width={('end_date' in values) && !showUnlimitedOption ? '100%' : '50%'}>
                            <VStack space={'0.2rem'} flex={1}>
                                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('startDateLabel')}{checkRequired('start_date' in values ? 'start_date' : 'date', validationObject)}</AppText>
                                <SharedTimepicker type={'date'} value={values['start_date' in values ? 'start_date' : 'date'] ? moment(values['start_date' in values ? 'start_date' : 'date'], dbDateFormat) : moment()} onChange={(date) => onDateChange('start_date' in values ? 'start_date' : 'date', date)} textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}/>
                            </VStack>
                            {'end_date' in values && !showUnlimitedOption &&
                                <VStack space={'0.2rem'} flex={1}>
                                    <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('endDateLabel')}{checkRequired('end_date', validationObject)}</AppText>
                                    <SharedTimepicker type={'date'} value={moment(values.end_date, dbDateFormat)} onChange={(date) => onDateChange('end_date', date)} textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}/>
                                </VStack>
                            }
                        </HStack>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.date}</AppText>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.start_date}</AppText>
                        {!showUnlimitedOption && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.end_date}</AppText>}
                    </VStack>
                    {showUnlimitedOption &&
                    <VStack>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('ends')}</AppText>
                        <Radio.Group name={'end-date-radio'} onChange={(e) => onUnlimitedSelectChange(e.target.value)} value={values.isOneDay ? 'oneDay' : (values.isUnlimited ? 'unlimited' : 'until')}>
                            <VStack>
                                <HStack space={'1rem'} alignItems={'center'} h={'40px'}>
                                    <Radio value="until" size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('set-date')}</AppText></Radio>
                                    {!values.isUnlimited && !values.isOneDay &&
                                    <SharedTimepicker type={'date'}
                                                      value={moment(values.end_date, dbDateFormat)}
                                                      onChange={(date) => onDateChange('end_date', date)}
                                                      textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}
                                                      min={values.start_date ?? moment().format(dbDateFormat)}
                                                      max={values.start_date ? moment(values.start_date, dbDateFormat).add(2,'y').format(dbDateFormat) : moment().add(2, 'y').format(dbDateFormat)}
                                    />}
                                </HStack>
                                <HStack h={'40px'} alignItems={'center'}>
                                    <Radio value="unlimited" size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('never')}</AppText></Radio>
                                </HStack>
                                <HStack h={'40px'} alignItems={'center'}>
                                    <Radio value="oneDay" size="sm">
                                    <HStack alignItems={'center'}>
                                        <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('one-day-course')}</AppText>
                                        <InfoTooltip title={t('one-day-hug-tooltip')}/>
                                    </HStack>
                                    </Radio>
                                </HStack>
                            </VStack>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.end_date}</AppText>
                        </Radio.Group>
                    </VStack>
                    }
                    {
                        'repeat' in values &&
                        <VStack space={'0.2rem'} flex={1}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('repeat')}</AppText>
                            <Radio.Group name={'repeat-type-radio'} onChange={(e) => setValue('repeat', e.target.value === 'repeat')} value={values.repeat ? 'repeat' : 'one-time'}>
                                <HStack space={'1.5rem'}>
                                    <Radio value="repeat" size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('on-going')}</AppText></Radio>
                                    <Radio value="one-time" size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('oneTime')}</AppText></Radio>
                                </HStack>
                            </Radio.Group>
                        </VStack>
                    }
                    {
                        'slot_length' in values &&
                        <VStack space={'0.2rem'} flex={1}>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('increments')}{checkRequired('slot_length', validationObject)}</AppText>
                            <NBText style={{direction: 'inherit'}}>
                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('time-slot-half-1')}</AppText>
                                <SimpleInput value={values.slot_length}
                                             onChangeCallback={(val) => setValue('slot_length', val, true)}
                                             numericOnly={true}
                                             max={999}
                                             width={'4rem'}
                                             styleOverride={{margin: '0 0.5rem'}}
                                             status={errors.slot_length ? 'error' : null}
                                />
                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('time-slot-half-2')}</AppText>
                            </NBText>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.slot_length}</AppText>
                        </VStack>
                    }
                    {
                        'break_length' in values &&
                        <VStack space={'0.2rem'} flex={1}>
                            <HStack>
                                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('break-length-header')}{checkRequired('break_length', validationObject)}</AppText>
                                <InfoTooltip title={t('break-length-tooltip')}/>
                            </HStack>
                            <NBText style={{direction: 'inherit'}}>
                                <SimpleInput value={values.break_length}
                                             onChangeCallback={(val) => setValue('break_length', val, true)}
                                             numericOnly={true}
                                             max={999}
                                             width={'4rem'}
                                             status={errors.break_length ? 'error' : null}
                                />
                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16} style={{marginHorizontal: '0.5rem'}}>{t('break-length-explain')}</AppText>
                            </NBText>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.break_length}</AppText>
                        </VStack>
                    }
                    {
                        'block_registration_time' in values && ![flowOptions.WORKSHOP_FLOW, flowOptions.HUGIM_FLOW, flowOptions.HUGIM_FROM_TRACK_FLOW].includes(flowName) &&
                        <VStack space={'0.2rem'} flex={1}>
                            <HStack>
                                <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('limitRegistrationTimeAvailability')}{checkRequired('block_registration_time', validationObject)}</AppText>
                                <InfoTooltip title={t('limitRegistrationTimeAvailabilityTooltip')}/>
                            </HStack>
                            <NBText style={{direction: 'inherit'}}>
                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('limit-registration-time-half-1')}</AppText>
                                <SimpleInput value={values.block_registration_time}
                                             onChangeCallback={(val) => setValue('block_registration_time', val, false)}
                                             inputType={'float'}
                                             width={'4rem'}
                                             styleOverride={{margin: '0 0.5rem'}}
                                             status={errors.block_registration_time ? 'error' : null}
                                />
                                <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t('limit-registration-time-half-2')}</AppText>
                            </NBText>
                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.block_registration_time}</AppText>
                        </VStack>
                    }
                    <VStack space={'0.2rem'}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText} mediumFont>{t('schedule-on')}</AppText>
                            {values.multiDayConfig?.days &&
                                <VStack space={'0.2rem'}>
                                    {daysWithOrder.map(day => {
                                        const selectedDayIndex = values.multiDayConfig.days.findIndex(d => d.day === day.id)
                                        const isSelected = selectedDayIndex !== -1
                                        const diffObj = isSelected ? getHourAndMinuteDiff(values.multiDayConfig.days[selectedDayIndex].start_time, values.multiDayConfig.days[selectedDayIndex].end_time) : null;
                                        const withDescription = showDayDescription && isSelected && !values.isOneDay
                                        return (
                                            <VStack space={'0.2rem'} key={`repeat-days-${day.id}`} padding={'0.5rem'}
                                                    bg={isSelected ? Colors.newDesign.menuBar : Colors.newDesign.white}
                                                    height={withDescription ? '5rem' : '3.5rem'}>
                                                <HStack space={'1rem'} alignItems={'center'} justifyContent={'space-between'}>
                                                    <CustomCheckbox text={day.name} isChecked={isSelected} onChange={() => toggleDay(!isSelected, day.id)} disabled={values.isOneDay}/>
                                                    {isSelected &&
                                                    <HStack space={mobile ? '1rem' : '2rem'} alignItems={'center'}>
                                                        <HStack space={'0.5rem'} alignItems={'center'}>
                                                            <SharedTimepicker type={'time'}
                                                                            value={moment(values.multiDayConfig.days[selectedDayIndex].start_time, dbTimeFormat)}
                                                                            onChange={(time) => onTimeChange(`multiDayConfig.days[${selectedDayIndex}].start_time`, time)}
                                                                            inputStyle={[WebGlobalStyles.customInputNew, mobile && {padding: '5px'}, {width: mobile ? '4.5rem' : '5.5rem'}]}
                                                                            textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}/>
                                                            <AppText fontSize={GlobalStyleAttributes.fonts.infoText}>-</AppText>
                                                            <SharedTimepicker type={'time'}
                                                                            value={moment(values.multiDayConfig.days[selectedDayIndex].end_time, dbTimeFormat)}
                                                                            onChange={(time) => onTimeChange(`multiDayConfig.days[${selectedDayIndex}].end_time`, time)}
                                                                            textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}
                                                                            inputStyle={[WebGlobalStyles.customInputNew, mobile && {padding: '5px'}, {width: mobile ? '4.5rem' : '5.5rem'}, (diffObj.hours + diffObj.minutes) <= 0 && {borderColor: Colors.error}]}
                                                            />
                                                        </HStack>
                                                    </HStack>
                                                    }
                                                </HStack>
                                                {withDescription && <HStack space={'0.2rem'}>
                                                    {!values.multiDayConfig.days[selectedDayIndex]?.description && 
                                                    <CustomButtonV2 onClick={() => openAddDescription(selectedDayIndex)} type={'link'} text={t('add-description')} iconName={'fa-plus'} textProps={{color: Colors.newDesign.mainBlue}} iconProps={{iconColor: Colors.newDesign.mainBlue}}/>}
                                                    {values.multiDayConfig.days[selectedDayIndex]?.description && 
                                                    <HStack space={'0.2rem'}>
                                                        <AppText>{`${t('description')}: ${values.multiDayConfig.days[selectedDayIndex]?.description}`}</AppText>
                                                        <CustomButtonV2 onClick={() => openAddDescription(selectedDayIndex)} type={'link'} iconName={'fa-pen'} iconProps={{iconColor: Colors.newDesign.mainText}}/>
                                                    </HStack>}
                                                </HStack>}
                                            </VStack>
                                    )})}
                                    {errors.multiDayConfig?.days && isString(errors.multiDayConfig.days) && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.multiDayConfig.days}</AppText>}
                                    <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.newDesign.darkGrey}>{generateSummary()}</AppText>
                                </VStack>
                            }
                            {Array.isArray(values.multiDayConfig) &&
                                <VStack space={'0.2rem'}>
                                    {daysWithOrder.map(day => {
                                        const selectedDayIndex = values.multiDayConfig.findIndex(d => d.day === day.id)
                                        const isSelected = selectedDayIndex !== -1
                                        return (
                                            <HStack space={'1rem'} key={`repeat-days-${day.id}`} p={'0.7rem'} bg={isSelected ? Colors.newDesign.menuBar : Colors.newDesign.white} minHeight={'3rem'} alignItems={'center'}>
                                                <HStack space={'1rem'} flex={1} alignSelf={isSelected && values.multiDayConfig[selectedDayIndex].setting.length > 1 ? 'start' : 'center'}>
                                                    <CustomCheckbox text={day.name} isChecked={isSelected} onChange={() => toggleDayFromArray(!isSelected, day.id)}/>
                                                </HStack>
                                                <VStack space={'0.5rem'}>
                                                    {isSelected && values.multiDayConfig[selectedDayIndex].setting.map((item, index) => {
                                                        const diffObj = getHourAndMinuteDiff(item.start_time, item.end_time)
                                                        return (
                                                            <HStack space={'1rem'} alignItems={'center'} key={`repeat-days-setting-${day.id}-${index}`}>
                                                                <Stack direction={mobile ? 'column' : 'row'} space={'0.5rem'} alignItems={'center'}>
                                                                    <HStack space={'0.5rem'} alignItems={'center'} w={mobile ? '100%' : 'auto'}>
                                                                        <SharedTimepicker type={'time'}
                                                                                          value={moment(item.start_time, dbTimeFormat)}
                                                                                          onChange={(time) => onTimeChange(`multiDayConfig[${selectedDayIndex}].setting[${index}].start_time`, time)}
                                                                                          wrapperStyle={[mobile && {flex:1}]}
                                                                                          textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}
                                                                                          inputStyle={[mobile ? {padding: '5px', width: '5rem'} : {width: '5.5rem'}]}/>
                                                                        <AppText fontSize={GlobalStyleAttributes.fonts.infoText}>-</AppText>
                                                                        <SharedTimepicker type={'time'}
                                                                                          value={moment(item.end_time, dbTimeFormat)}
                                                                                          onChange={(time) => onTimeChange(`multiDayConfig[${selectedDayIndex}].setting[${index}].end_time`, time)}
                                                                                          wrapperStyle={[mobile && {flex:1}]}
                                                                                          textStyle={{fontSize: GlobalStyleAttributes.fonts.standard16}}
                                                                                          inputStyle={[mobile ? {padding: '5px', width: '5rem'} : {width: '5.5rem'}, (diffObj.hours + diffObj.minutes) <= 0 && {borderColor: Colors.error}]}/>
                                                                    </HStack>
                                                                    {sessionTypes && sessionTypes.length > 0 && <MultiSingleMenuWithSearch options={sessionTypes}
                                                                                                                                           onChange={(val) => handleLimitationChange(val, selectedDayIndex, index)}
                                                                                                                                           placeholder={mobile ? t('choose') : t('select-services')}
                                                                                                                                           width={mobile ? '100%' : '150px'}/>}
                                                                </Stack>
                                                                <CustomButtonV2 onClick={() => index === 0 ? addSettingToDay(selectedDayIndex) : removeSettingFromDay(selectedDayIndex, index)}
                                                                                type={'link'}
                                                                                iconName={index === 0 ? 'fa-plus' : 'fa-trash-can'}
                                                                                iconProps={index === 0 ? {iconColor: Colors.newDesign.mainBlue} : {}}
                                                                />
                                                            </HStack>
                                                        )
                                                    })}
                                                </VStack>
                                            </HStack>
                                        )})}
                                    {isString(errors.multiDayConfig) && <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.error} mediumFont>{errors.multiDayConfig}</AppText>}
                                    <AppText fontSize={GlobalStyleAttributes.fonts.infoText} color={Colors.newDesign.darkGrey}>{generateSummaryFromArray()}</AppText>
                                </VStack>
                            }
                    </VStack>
                </VStack>
                :
                <ActivityIndicator/>
            }
        </>
    );
};

export default MultiDayConfiguration;
